const shippingForm = document.getElementById('js-shipping-form')

if (shippingForm) {
  const deliveryZip = document.getElementById('delivery-zip')
  if (deliveryZip) {
    deliveryZip.addEventListener('submit', (e) => {
      e.preventDefault()

      const inputs = deliveryZip.querySelectorAll('input')
      const data = new FormData()
      inputs.forEach((input) => {
        data.append(input.getAttribute('name'), input.value)
      })

      document.getElementById('shop-loader').classList.remove('hidden')

      deliveryZip.classList.add('hidden')

      fetch('/address', {
        method: 'post',
        body: data,
      }).then(() =>
        setTimeout(() => {
          window.location.reload()
        })
      )
    })
  }

  const shippingInputs = document.querySelectorAll('input[name=shipping_id]')
  const shopsWrapper = document.querySelector('.shipping__shops')

  const checkShippingClass = (shipping) => {
    if (shipping.checked) {
      shipping.parentElement.classList.add('shipping__option--active')
    } else {
      shipping.parentElement.classList.remove('shipping__option--active')
    }
  }

  if (shippingInputs.length) {
    let initialModule = '0'

    shippingInputs.forEach((shipping) => {
      checkShippingClass(shipping)

      if (shipping.checked) {
        if (shipping.getAttribute('module') !== '0') {
          initialModule = shipping.getAttribute('module')
          if (shopsWrapper) {
            shopsWrapper.classList.add('shipping__shops--open')
          }
        }
      }

      shipping.addEventListener('change', (event) => {
        document.querySelectorAll('.shipping__shops').forEach((shops) => {
          shops.classList.remove('shipping__shops--open')
        })

        document
          .querySelector('.shipping__option')
          .classList.remove('shipping__option--active')

        if (event.target.checked) {
          if (event.target.getAttribute('module') !== '0') {
            if (initialModule !== event.target.getAttribute('module')) {
              shippingForm.submit()
            } else {
              const y =
                event.target.getBoundingClientRect().top + window.scrollY - 50
              window.scrollTo({ top: y, behavior: 'smooth' })
              if (shopsWrapper) {
                shopsWrapper.classList.add('shipping__shops--open')
              }
            }
          }
        }

        shippingInputs.forEach((shipping) => {
          checkShippingClass(shipping)
        })
      })
    })
  }
}
